module.exports = __webpack_public_path__ + "img/Druid.2be25c78.png";